import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OrganisationBase } from '../models/organisation-base';

@Injectable({
  providedIn: 'root'
})
export class SelectedOrganisationService {

  private _selectedOrgsSubject = new BehaviorSubject<OrganisationBase[]>([]);
  public selectedOrgs$ = this._selectedOrgsSubject.asObservable();

  constructor() { }

  selectOrganisation(organisation: OrganisationBase | null) {
    console.log('Selected organisation: ', organisation);

    let currentValue = this._selectedOrgsSubject.getValue();
    let valueUnchanged = currentValue.length == 0 ? organisation == null : currentValue[0] == organisation;

    if (valueUnchanged)
      return;

    this._selectedOrgsSubject.next(organisation == null ? [] : [ organisation ]);
  }

  selectOrganisations(organisations: OrganisationBase[]) {
    console.log('Selected organisations: ', organisations);
    this._selectedOrgsSubject.next(organisations);
  }
}
